module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/User-folder-56b70702df1cfcc8a4be9d1e908851ac.svg";